<template>
  <div v-if="records.length">
    <v-popover
      :auto-hide="true"
    >
      <button class="btn btn-default">
        <i class="icon-fa icon-fa-history"/>
      </button>
      <template slot="popover">
        <div>
          <table class="table mt-0 table-sm">
            <tbody>
            <tr v-for="r in records">
              <td>{{ printDate(r.created_at) }}</td>
              <td>{{ r.qty }}</td>
              <td>
                <UserName :id="r.user_id"/>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </template>
    </v-popover>
  </div>
</template>

<script>

import UserName from "@/components/users/UserName.vue";

export default {
  components: {UserName},
  props: ['records']
}

</script>
